export default {
  sui: {
    loading: {
      text: 'กำลังโหลด'
    },
    form: {
      more: 'เพิ่มเติม',
      zhankai: 'เพิ่มเติม',
      shouqi: 'ซ่อน',
      query: 'สอบถาม',
      reset: 'รีเซ็ต',
      add: 'เพิ่ม',
      update: 'อัปเดต',
      delete: 'ลบ',
      required: 'จำเป็นต้องกรอก',
      export: {
        export: 'ส่งออก',
        selectFormat: 'เลือกรูปแบบ',
        selectedRow: 'เลือก {key} แถว',
        selectedTotal: 'ทั้งหมด {key} บรรทัด, ส่งออก',
        line: 'บรรทัด'
      },
      please: {
        input: 'กรุณาป้อน ',
        select: 'กรุณาเลือก '
      },
      time: {
        start: 'เวลาเริ่มต้น',
        end: 'เวลาสิ้นสุด',
        to: 'ถึง'
      },
      date: {
        start: 'วันที่เริ่มต้น',
        end: 'วันที่สิ้นสุด'
      },
      upload: {
        triggerText: 'อัปโหลด'
      },
      expand: 'ขยาย',
      multiple: 'หลายรายการ',
      cols_hide: 'การตั้งค่าส่วนหัว'
    },
    table: {
      handle: 'จัดการ',
      sum: 'ผลรวม',
      index: 'ดัชนี',
      zanwushuju: 'ไม่มีข้อมูล',
      queding: 'ตกลง',
      quxiao: 'ยกเลิก',
      lie: 'คอลัมน์',
      yiyincang: 'ซ่อน',
      gong: 'ทั้งหมด'
    },
    tableEdit: {
      tip1: 'ข้อมูลยังอยู่ในสถานะแก้ไขและไม่สามารถบันทึกได้!',
      tip2: 'คุณแน่ใจหรือไม่ที่จะลบข้อมูล?',
      baocun: 'บันทึก',
      chongzhi: 'รีเซ็ต',
      xinzeng: 'เพิ่ม',
      guanbituozhuai: 'ปิดการลาก',
      kaiqituozhuai: 'เปิดการลาก',
      caozuo: 'จัดการ',
      queren: 'ตกลง',
      bianji: 'แก้ไข',
      shanchu: 'ลบ',
      tishi: 'เคล็ดลับ'
    },
    list: {
      yi_xuan_ze: 'เลือกแล้ว',
      tiao: 'รายการ',
      gong: 'ทั้งหมด',
      mei_you_geng_duo: 'ไม่มีเพิ่มเติม',
      zan_wu_shu_ju: 'ยังไม่ได้เลือกข้อมูล'
    },
    bond: {
      zheng_quan_dai_ma: 'รหัสพันธบัตร',
      zheng_quan_ming_cheng: 'ชื่อพันธบัตร',
      zan_wu_shu_ju: 'ไม่มีข้อมูล',
      qu_xiao_qing_qiu: 'ยกเลิกคำขอแล้ว'
    },
    dialog: {
      ok: 'ตกลง',
      cancel: 'ยกเลิก'
    },
    page: {
      add: {
        success: 'เพิ่ม [{key}] สำเร็จ'
      },
      delete: {
        title: '{key}-ลบ',
        confirm: 'ยืนยันลบ [{key}] ?',
        success: 'ลบ [{key}] สำเร็จ'
      },
      update: {
        success: 'อัปเดต [{key}] สำเร็จ',
        noChange: 'ข้อมูลไม่เปลี่ยนแปลง ไม่บันทึก'
      }
    },
    tablePage: {
      export: {
        tip1: 'กรุณาป้อนหมายเลขบรรทัดที่ถูกต้อง',
        tip2: 'ประเภทการส่งออก',
        tip3: 'เลือก',
        tip4: ' ส่งออกเป็น',
        tip5: 'กรุณาเลือกประเภทไฟล์ส่งออก',
        lie: 'คอลัมน์',
        hang: 'บรรทัด',
        shi: 'ใช่',
        fou: 'ไม่',
        daochu: 'ส่งออก',
        wancheng: 'ยืนยัน',
        quxiao: 'ยกเลิก',
        gong: 'ทั้งหมด',
        type1: 'ส่งออกตามลำดับ',
        type2: 'ส่งออกที่เลือกด้วยตนเอง',
        daochu_geshi: 'ประเภทไฟล์ส่งออก'
      }
    },
    editlist: {
      caozuo: 'จัดการ',
      shanchu: 'ลบ',
      xinzeng: 'เพิ่ม'
    },
    upload: {
      tip1: 'กดปุ่มลบเพื่อลบ'
    },
    uploadPro: {
      tip1: 'การเชื่อมต่อ Websocket หายไป กำลังพยายามเชื่อมต่ออีกครั้ง',
      tip2: 'การเชื่อมต่อหลุด'
    },
    select: {
      jiazaizhong: 'กำลังโหลด',
      wupipeishuju: 'ไม่มีข้อมูลที่ตรงกัน',
      wushuju: 'ไม่มีข้อมูล',
      quanxuan: 'เลือกทั้งหมด',
      fanxuan: 'กลับการเลือก'
    },
    transfer: {
      tip1: 'ค้นหา',
      liebiao1: 'รายการ 1',
      liebiao2: 'รายการ 2'
    },
    treeGrid: {
      caozuolan: 'จัดการ'
    },
    empty: {
      zanwuneirong: 'ไม่มีข้อมูล'
    },
    valid: {
      char: 'อักขระ',
      len1: 'กรุณาป้อน {p1} ',
      len2: 'กรุณาป้อน {p1} ถึง {p2} ',
      num: 'ตัวเลข',
      pInt: 'จำนวนเต็มบวก',
      npInt: 'จำนวนเต็มไม่เป็นบวก',
      nInt: 'จำนวนเต็มลบ',
      nNInt: 'จำนวนเต็มไม่เป็นลบ',
      int: 'จำนวนเต็ม',
      pFNum: 'จำนวนทศนิยมบวก',
      nFNum: 'จำนวนทศนิยมลบ',
      num_: 'ตัวเลข(-,_)',
      en: 'อักษรภาษาอังกฤษ',
      en_: 'อักษรภาษาอังกฤษ(-,_)',
      ch: 'อักษรภาษาจีน',
      ch_: 'อักษรภาษาจีน(-,_)',
      nch: 'ไม่ใช่อักษรภาษาจีน',
      numEn: 'ตัวเลขหรืออักษรภาษาอังกฤษ',
      numEn_: 'ตัวเลขหรืออักษรภาษาอังกฤษ(-,_)',
      chEnNum: 'ตัวเลขหรืออักษรภาษาอังกฤษหรืออักษรภาษาจีน',
      chEnNum_: 'ตัวเลขหรืออักษรภาษาอังกฤษหรืออักษรภาษาจีน(-,_)',
      phone: 'หมายเลขโทรศัพท์',
      email: 'อีเมล',
      idcard: 'บัตรประจำตัวประชาชน',
      url: 'URL',
      reg: 'กรุณาป้อนให้ถูกต้อง ',
      version: 'แท็กเวอร์ชัน',
      uri: 'URI',
      datasource: 'แหล่งข้อมูล',
      intRegion: 'จำนวนเต็มระหว่าง {p1} ถึง {p2}',
      floatRegion: 'ทศนิยมระหว่าง {p1} ถึง {p2}'
    },
    timerange: {
      jue_dui_shi_jian_fan_wei: 'ช่วงเวลาสัมบูรณ์',
      xiang_dui_shi_jian_fan_wei: 'ช่วงเวลาสัมพัทธ์',
      kai_shi_shi_jian: 'เวลาเริ่มต้น',
      jie_su_shi_jian: 'เวลาสิ้นสุด',
      zui_jin_wu_fen_zhong: '5 นาทีที่ผ่านมา',
      zui_jin_shi_wu_fen_zhong: '15 นาทีที่ผ่านมา',
      zui_jin_san_shi_fen_zhong: '30 นาทีที่ผ่านมา',
      zui_jin_yi_xiao_shi: '1 ชั่วโมงที่ผ่านมา',
      zui_jin_san_xiao_shi: '3 ชั่วโมงที่ผ่านมา',
      zui_jin_liu_xiao_shi: '6 ชั่วโมงที่ผ่านมา',
      zui_jin_shi_er_xiao_shi: '12 ชั่วโมงที่ผ่านมา',
      zui_jin_er_shi_si_xiao_shi: '24 ชั่วโมงที่ผ่านมา',
      zui_jin_liang_tian: '2 วันที่ผ่านมา',
      zui_jin_qi_tian: '7 วันที่ผ่านมา',
      zui_jin_san_shi_tian: '30 วันที่ผ่านมา'
    },
    bookmark: {
      biao_ti: 'บุ๊กมาร์ก',
      xin_zeng_shu_qian: 'เพิ่มบุ๊กมาร์ก',
      ming_cheng: 'ชื่อ',
      fu_gai: 'ทับ',
      chong_ming_ming: 'เปลี่ยนชื่อ',
      shan_chu: 'ลบ',
      ming_cheng_xiu_gai_cheng_gong: 'แก้ไขชื่อสำเร็จ',
      xin_zeng: 'เพิ่ม',
      shan_chu_ti_shi: 'ยืนยันลบ [{name}] ?',
      shan_chu_cheng_gong: 'ลบสำเร็จ',
      xin_zeng_cheng_gong: 'เพิ่มบุ๊กมาร์กสำเร็จ!',
      tian_jia_ji_lu: 'เพิ่มไปยังประวัติ',
      gong: 'ทั้งหมด',
      tiao: 'รายการ',
      bao_cun: 'บันทึก',
      qing_wan_cheng_zheng_zai_tian_jia_xiang: 'กรุณายืนยันว่ากำลังเพิ่มบันทึก'
    },
    messageBox: {
      qing_shuru_yanzhengma: 'กรุณาป้อนรหัสยืนยัน',
      yanzhengma_bu_zhengque: 'รหัสยืนยันไม่ถูกต้อง'
    },
    jsonEditor: {
      fuzhi: 'คัดลอก'
    },
    cron: {
      second: 'วินาที',
      minute: 'นาที',
      hour: 'ชั่วโมง',
      day: 'วัน',
      month: 'เดือน',
      week: 'สัปดาห์',
      year: 'ปี',
      cron_biaodashi_ziduan: 'ฟิลด์นิพจน์ Cron',
      hanhua_fanyi: 'คำแปลภาษาจีน',
      chongzhi: 'รีเซ็ต',
      single: 'ต่อ ',
      mei_nian: 'ต่อปี',
      mei_yue: 'ต่อเดือน',
      mei_ri: 'ต่อวัน',
      mei_tian: 'ต่อวัน',
      mei_shi: 'ต่อชั่วโมง',
      xiaoshi: 'ชั่วโมง',
      mei_fenzhong: 'ต่อนาที',
      mei_miao: 'ต่อวินาที',
      mei_zhou: 'ต่อสัปดาห์',
      cong: 'จาก',
      yue_qi_mei_ge: 'ทุกเดือน',
      ri_qi_mei_ge: 'ทุกวัน',
      shi_qi_mei_ge: 'ทุกชั่วโมง',
      fenzhong_qi_mei_ge: 'ทุกนาที',
      miao_qi_mei_ge: 'ทุกวินาที',
      zuihou_yitian: 'วันสุดท้าย',
      zhi: 'ถึง',
      cong_zhou: 'จากสัปดาห์',
      zhi_zhou: 'ถึงสัปดาห์',
      qi_meige: 'ทุก',
      tian_zhixingyici: ' วันละครั้ง',
      xiaoshi_zhixingyici: ' ชั่วโมงละครั้ง',
      yue_zhixingyici: ' เดือนละครั้ง',
      zhixingyici: ' ทำงานครั้งเดียว',
      ben_yue_di: 'เดือนนี้',
      ben_yue: 'เดือนนี้',
      xinqi: 'สัปดาห์',
      benyue_zuihou_yige_xingqi: 'สัปดาห์สุดท้ายของเดือน',
      buzhiding: 'ไม่ระบุ',
      zhouqi_cong: 'วงจรจาก',
      xunhuan_cong: 'วนจาก',
      tip1: 'ทุกวัน',
      tip2: 'วันทำงานที่ใกล้ที่สุด',
      tip3: 'เริ่มต้น ทุกชั่วโมง',
      tip4: 'เริ่มต้น ทุกเดือน',
      tip5: 'วันของสัปดาห์',
      benyue_zuihou_yitian: 'วันสุดท้ายของเดือน',
      zhiding: 'ระบุ',
      kaishi: 'เริ่มต้น',
      kaishi_mei: 'เริ่มต้นทุก',
      benyue: 'เดือนนี้',
      mei: 'ทุก',
      zhixing: 'ดำเนินการ',
      zhouqi: 'วงจร',
      di: 'เลขที่',
      mess1: "วันที่และสัปดาห์ไม่สามารถเป็น 'ไม่ระบุ' พร้อมกันได้",
      mess2: "หนึ่งในวันและสัปดาห์ต้องเป็น 'ไม่ระบุ'",
      zhouri: 'วันอาทิตย์',
      zhouyi: 'วันจันทร์',
      zhouer: 'วันอังคาร',
      zhousan: 'วันพุธ',
      zhousi: 'วันพฤหัสบดี',
      zhouwu: 'วันศุกร์',
      zhouliu: 'วันเสาร์'
    },
    treeGraph: {
      fangda: 'ขยาย',
      suoxiao: 'ย่อ',
      shuaxin: 'รีเฟรช'
    }
  }
} 



// WEBPACK FOOTER //
// ./src/components/SimbartUI/lang/th-TH.js